/* eslint-disable camelcase */
/**
 * 全站路由配置
 *
 * 建议:
 * 1. 代码中路由统一使用name属性跳转(不使用path属性)
 */
import Vue from 'vue'
import Router from 'vue-router'
import { isURL } from '@/utils/validate'
import { getUserMenue } from '@/api/menu'
import { Message } from 'element-ui'

Vue.use(Router)
// 解决路由重复跳转报错
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
// 修改原型对象中的push函数
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 修改原型对象中的replace函数
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)
const globalRoutes = [
  { path: '/login', component: () => import('@/views/common/login'), name: 'login', meta: { title: '登录' } }
]
const mainRoutes = [
  {
    path: '/',
    redirect: '/management-system',
    component: () => import('@/views/layout/index'),
    name: 'Layout',
    children: [{
      path: '/management-system',
      component: () => import('@/views/managementSystem/index'),
      children: []
    }]
  }
]
const router = new Router({
  mode: 'history',
  base:
    process.env.NODE_ENV === 'development'
      ? process.env.BASE_URL
      : '/qingteng',
  scrollBehavior: () => ({ y: 0 }),
  isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
  routes: globalRoutes
})

router.beforeEach(async (to, from, next) => {
  // 添加动态(菜单)路由
  // 1. 已经添加 or 全局路由, 直接访问
  // 2. 获取菜单列表, 添加并保存本地存储
  if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
    next()
  } else {
    try {
      const { data = {} } = await getUserMenue()
      const { menuList = [] } = data

      if (!menuList.length) {
        Message.error('用户暂无任何权限，请联系管理员')
        setTimeout(() => {
          location.reload()
        }, 2000)
        return false
      }
      if (menuList[0].url === 'workbench') { // 处理工作台
        menuList[0].list = ''
      }
      fnAddDynamicMenuRoutes(menuList)
      router.options.isAddDynamicMenuRoutes = true
      sessionStorage.setItem('menuList', JSON.stringify(menuList || '[]'))
      next({ ...to, replace: true })
    } catch (error) {
      console.log(`%c${error} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue')
      next({ name: 'login' })
    }
  }
})

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType(route, globalRoutes = []) {
  var temp = []
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global'
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : '/'
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].list && menuList[i].list.length >= 1) {
      temp = temp.concat(menuList[i].list)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      var route = {
        path: menuList[i].url.replace('/', '-'),
        component: null,
        name: menuList[i].url.replace('/', '-'),
        meta: {
          menuId: menuList[i].menuId,
          title: menuList[i].name,
          isDynamic: true,
          isTab: true,
          iframeUrl: ''
        }
      }
      // url以http[s]://开头, 通过iframe展示
      if (isURL(menuList[i].url)) {
        route['path'] = `i-${menuList[i].menuId}`
        route['name'] = `i-${menuList[i].menuId}`
        route['meta']['iframeUrl'] = menuList[i].url
      } else {
        try {
          route['component'] = _import(`managementSystem/${menuList[i].url}/index`) || null
        } catch (e) { }
      }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes)
  } else {
    const root = mainRoutes.find(route => route.path === '/')
    const managementSystem = root.children.find(route => route.path === '/management-system')
    routes.push({ path: '*', component: () => import('@/views/common/404'), name: 'NOTFOUND', meta: { title: '404未找到' } })
    managementSystem.children = routes
    const list = [
      ...mainRoutes,
      { path: '*', component: () => import('@/views/common/404'), name: '404', meta: { title: '404未找到' } }
    ]
    list.forEach(r => {
      router.addRoute(r)
    })

    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(managementSystem.children || '[]'))
  }
}

export default router
